import { sendUTXOTransaction, } from '../../actions/sendUTXOTransaction.js';
import { signPsbt } from '../../actions/signPsbt.js';
export function walletActions(client) {
    return {
        sendUTXOTransaction: (args) => sendUTXOTransaction(client, args),
        signPbst: (args) => signPsbt(client, args),
    };
}
//# sourceMappingURL=wallet.js.map